// extracted by mini-css-extract-plugin
export default {"modal":"ammodal_modal__euWAA"};